import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { isEmpty } from 'lodash-es';

import {
  ChangeOmaUserDetailsRequest,
  ChangeUserDetailsRequest,
  Gender,
  Salutation,
} from '@vi-iot/client';

import { PATTERN } from '@common';
import { PersonalDetailsFormGroup } from './personal-details.helper';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalDetailsComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  formGroup: FormGroup<PersonalDetailsFormGroup>;
  genders = Object.values(Gender);
  salutations = Object.values(Salutation);

  @Input() userRole: {
    id: string;
    role: string;
    type: string;
  };

  @Input() details: {
    salutation: Salutation;
    firstName: string;
    lastName: string;
    gender: Gender;
  };

  @Input() isEmailVerified: boolean;

  @Input() isOmaUser: boolean;

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  @Output() save: EventEmitter<ChangeUserDetailsRequest> = new EventEmitter<
    ChangeUserDetailsRequest
  >();

  @Output() omaSave: EventEmitter<ChangeOmaUserDetailsRequest> = new EventEmitter<
    ChangeOmaUserDetailsRequest
  >();

  ngOnInit(): void {
    this.formGroup = new FormGroup<PersonalDetailsFormGroup>({
      salutation: new FormControl<Salutation>(this.details.salutation),
      gender: new FormControl<Gender>(this.details.gender),
      firstName: new FormControl<string>(this.details.firstName, [
        Validators.required,
        Validators.pattern(PATTERN.NO_SPACES),
      ]),
      lastName: new FormControl<string>(this.details.lastName, [
        Validators.required,
        Validators.pattern(PATTERN.NO_SPACES),
      ]),
    });
  }

  onCancel(): void {
    this.cancel.emit();
  }

  dispatchSave(): void {
    if (this.isOmaUser) {
      this.onOmaSave();
    } else {
      this.onSave();
    }
  }

  onSave(): void {
    const { firstName, lastName, gender } = this.formGroup.value;
    const payload: ChangeUserDetailsRequest = {
      name: {
        firstName: firstName?.trim(),
        familyName: lastName?.trim(),
      },
      gender,
    };

    if (isEmpty(payload)) {
      this.onCancel();
    } else {
      this.save.emit(payload);
    }
  }

  onOmaSave(): void {
    const { firstName, lastName, salutation } = this.formGroup.value;
    const payload: ChangeOmaUserDetailsRequest = {
      name: {
        firstName: firstName?.trim(),
        familyName: lastName?.trim(),
      },
      salutation,
    };

    if (isEmpty(payload)) {
      this.onCancel();
    } else {
      this.omaSave.emit(payload);
    }
  }
}
